@if (label) {
  <p id="label">{{ label }}</p>
}
<button id="dropdown-btn" #button [disabled]="disabled" (click)="openDropdown()">
  <span class="pr-3">{{ selectedText }}</span>
  <i class="fa-solid fa-caret-down"></i>
</button>

@if (showDropdownMenu) {
  <div id="dropdown-menu" #dropdownMenu data-testid="dropdown-menu">
    @if (optionsCopy?.length > 0 || groupOptionsCopy?.length > 0) {
      @if (enableSearch) {
        <div id="search-box">
          <input
            type="text"
            class="form-control form-control-sm"
            [placeholder]="'SEARCH' | translate"
            (input)="search($event)"
            />
          </div>
        }
        @if (showSelectAll) {
          <span id="select-all" (click)="selectAll()">
            <i class="fas fa-check mr-1"></i>{{ "SELECT_ALL" | translate }}
          </span>
        }
        <span id="untick-all" (click)="untickAll()"><i class="fas fa-xmark fa-lg mr-1"></i>{{ "UNTICK_ALL" | translate }}</span>
        <div class="option-list mt-2">
          @for (option of options; track option) {
            @if (!option.hidden) {
              <div
                (click)="toggleCheckbox(checkbox, option.value, $event.target)"
                [ngClass]="['option-item', !option.disabled ? 'item-hover-enabled' : 'item-hover-disabled']"
                data-testid="option-list"
                >
                <span class="option-text" [innerHTML]="option.name | translate | highlight : searchText"></span>
                <mat-checkbox
                  #checkbox
                  [disabled]="option.disabled"
                  [checked]="isSelected(option.value)">
                </mat-checkbox>
              </div>
            }
          }
          @for (group of groupedOptions; track group; let i = $index) {
            <div class="option-group">
              <span [ngClass]="group.disabled ? 'group-title-disabled' : 'group-title-enabled'">
                {{ group.label | translate }}
                <span class="ml-1" [ngClass]="group.iconClass"></span>
              </span>
              @for (option of group.options; track option) {
                <div
                  (click)="toggleCheckbox(checkbox, option.value, $event.target)"
                  [ngClass]="['option-item', !group.disabled && !option.disabled ? 'item-hover-enabled' : 'item-hover-disabled']"
                  data-testid="option-group-list"
                  >
                  <span class="option-text" [innerHTML]="option.name | translate | highlight : searchText"></span>
                  <mat-checkbox
                    #checkbox
                    [disabled]="option.disabled || group.disabled"
                    [checked]="isSelected(option.value)">
                  </mat-checkbox>
                </div>
              }
            </div>
          }
        </div>
      } @else {
        <span id="option-warning-text">{{ "NO_OPTIONS" | translate }}</span>
      }
    </div>
  }
